import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { Shield, Award, Lock, Heart } from 'lucide-react';

const values = [
  {
    icon: Shield,
    title: 'Vertrauen',
    description: 'Unsere Klienten vertrauen uns, weil wir Wort halten. Was wir zusagen, setzen wir um.'
  },
  {
    icon: Lock,
    title: 'Verschwiegenheit',
    description: 'Über unsere Klienten sprechen wir nicht. Mit niemandem, zu keinem Zeitpunkt.'
  },
  {
    icon: Award,
    title: 'Sorgfalt',
    description: 'Wir planen alles genau, bevor es losgeht.'
  },
  {
    icon: Heart,
    title: 'Persönlicher Kontakt',
    description: 'Ein fester Ansprechpartner, der Ihre Situation kennt und erreichbar ist.'
  },
];

export const AboutSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="ueber-uns"
      className="section-padding bg-[#111625]"
      data-testid="about-section"
    >
      <div className="container-custom">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto"
        >
          <div className="text-center mb-12">
            <span className="text-[#D4AF37] uppercase tracking-[0.3em] text-xs font-medium">
              Über uns
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-[#F1F5F9] mt-4 font-['DM_Sans']">
              Unsere Werte
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {values.map((value, index) => {
              const Icon = value.icon;
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={isInView ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="flex gap-4 p-6 bg-[#0B0F19] border border-[#1E293B] rounded-sm hover:border-[#D4AF37]/30 transition-colors group"
                  data-testid={`value-card-${index}`}
                >
                  <div className="w-12 h-12 flex-shrink-0 rounded-sm bg-[#1A2030] flex items-center justify-center group-hover:bg-[#D4AF37]/10 transition-colors">
                    <Icon size={24} className="text-[#D4AF37]" />
                  </div>
                  <div>
                    <h4 className="text-[#F1F5F9] font-semibold mb-2 font-['DM_Sans'] text-lg">
                      {value.title}
                    </h4>
                    <p className="text-[#94A3B8] text-sm leading-relaxed">
                      {value.description}
                    </p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
